export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--W.8002ec24.png";